import { POST, postFile, GET } from "../../index";

export const getJurisdictionSurvey = (param) => POST("/v1/jurisdictionSynthesize/getJurisdictionSurvey", param);
export const getDriverCarRate = (param) => POST("/v1/jurisdictionSynthesize/getDriverCarRate", param);
export const getDeviceDismantle = (param) => POST("/v1/jurisdictionSynthesize/getDeviceDismantle", param);
export const getCarEmissionRate = (param) => POST("/v1/jurisdictionSynthesize/getCarEmissionRate", param);
export const getSafetyDeviceRate = (param) => POST("/v1/jurisdictionSynthesize/getSafetyDeviceRate", param);
export const getCarAgeRate = (param) => POST("/v1/jurisdictionSynthesize/getCarAgeProportion", param);
export const getCarMaintainRate = (param) => POST("/v1/jurisdictionSynthesize/getCarMaintainRate", param);
export const getCheckRate = (param) => POST("/v1/jurisdictionSynthesize/getCarSpotCheckRate", param);
export const getSpotCheckAbnormalRate = (param) => POST("/v1/jurisdictionSynthesize/getSpotCheckAbnormalRate", param);

